// I have no idea what this is meant to be as it's used as a component elsewhere
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Img = ({ src, ...rest }) => {
    return {
        image: src,
        ...rest
    };
};
export default Img;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW1nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbXBvbmVudHMvSW1nLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPQSxnRkFBZ0Y7QUFDaEYsOERBQThEO0FBQzlELE1BQU0sR0FBRyxHQUFHLENBQUMsRUFBRSxHQUFHLEVBQUUsR0FBRyxJQUFJLEVBQVksRUFBTyxFQUFFO0lBQzlDLE9BQU87UUFDTCxLQUFLLEVBQUUsR0FBRztRQUNWLEdBQUcsSUFBSTtLQUNSLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixlQUFlLEdBQUcsQ0FBQyJ9